import React from 'react';
import {Link, LinkProps} from 'react-router-dom';
import {Scheme} from '../../types/url.ts';

type Props = {
    forceButton?: boolean;
} & LinkProps;

export default React.forwardRef<HTMLAnchorElement, Props>(
    ({to, children, forceButton, ...props}, ref) => {
        if (typeof to === 'string' && to.startsWith(Scheme.Https)) {
            return (
                <a ref={ref} href={to} {...props}>
                    {children}
                </a>
            );
        }
        if (typeof to === 'object' && to.pathname?.startsWith(Scheme.Https)) {
            return (
                <a ref={ref} href={to.pathname} {...props}>
                    {children}
                </a>
            );
        }

        if (!forceButton) {
            props.className = ((props.className || '') + ' link').trim();
        }

        return (
            <Link to={to} ref={ref} {...props}>
                {children}
            </Link>
        );
    },
);
